// Reasons a buyer can pick when requesting a return. Buyer's remorse reasons
// carry a restocking fee, seller-fault reasons do not.
export const RETURN_REASONS = [
  { value: 'Item not as described/missing parts', restocking_fee: false },
  { value: 'No longer needed/ordered by mistake', restocking_fee: true },
  { value: "Wrong size/doesn't fit", restocking_fee: true },
  { value: 'Product damaged', restocking_fee: false },
] as const;

export type ReturnReason = (typeof RETURN_REASONS)[number]['value'];

export function returnReasonHasRestockingFee(
  reason?: string | null
): boolean | null {
  const match = RETURN_REASONS.find((r) => r.value === reason);
  return match ? match.restocking_fee : null;
}

// Appends the restocking fee status in parentheses. Reasons outside
// RETURN_REASONS (free text from older returns) are returned untouched.
export function formatReturnReason(reason?: string | null): string {
  if (!reason) return '';
  const hasFee = returnReasonHasRestockingFee(reason);
  if (hasFee === null) return reason;
  return `${reason} (${hasFee ? 'restocking fee' : 'no restocking fee'})`;
}

export const returnReasonSelectOptions = RETURN_REASONS.map(({ value }) => ({
  id: value,
  value,
  label: value,
}));

export const annotatedReturnReasonSelectOptions = RETURN_REASONS.map(
  ({ value }) => ({
    id: value,
    value,
    label: formatReturnReason(value),
  })
);
